'use strict';

import React, { useState } from 'react';
import get from 'lodash/get';
import Notification from '../../Notification';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { formatDate, formatTime, getTime } from '../../../utils/TimeUtils';
import { getDepartmentDisplay } from '../../../utils/TimelineUtils';
import Loader from '../../Loader';
import OTIcon from '../../tag/OTIcon';
import OTButton from '../../tag/OTButton';
import { doRequestDismissNotificationsList } from '../../../data/notification/actions';
import { QUESTIONNAIRE_PAGE_NOTIFICATION } from '../../../definitions/NotificationConstants';
import OTButtonGroup from '../../tag/OTButtonGroup';
import Row from '../../tag/Row';
import { showOmavointiQuestionnaireModal } from '../../../data/questionnaires/actions';
import { QUESTIONNAIRES } from '../../../data/reducer';
import MobileClientModal from '../MobileClientModal';
import { LONG_DESCRIPTON_FORM_CODE } from '../../../definitions/QuestionnaireConstants';

const { id: module_id } = module;

function QuestionnaireNotificationList(props) {
  const [showMobileClientModal, setShowMobileClientModal] = useState(false);

  const toggleModalState = () => {
    setShowMobileClientModal(!showMobileClientModal);
  };

  const fillClicked = (data) => {
    let { showOmavointiQuestionnaireModal, mobileClientState } = props;

    !mobileClientState
      ? showOmavointiQuestionnaireModal(data.formCode)
      : toggleModalState();
    return null;
  };

  /*
    If the questionnaire is 15d, show the description given in the data.
    Else show generic description
   */
  const renderLongDescription = (questionnaire) => {
    return questionnaire.formCode === LONG_DESCRIPTON_FORM_CODE ? (
      questionnaire.longDescription && (
        <div className="ot-notification__description">
          {questionnaire.longDescription}
        </div>
      )
    ) : (
      <div className="ot-notification__description">
        <FormattedMessage id={`${module_id}.generic.info`} />
      </div>
    );
  };

  const getDescription = (item) => {
    if (item && !item.showActiveQuestionnaireDescription) {
      return <Loader style={{ margin: '40px auto' }} />;
    }
    if (item) {
      return (
        <FormattedMessage
          id={`${module_id}.fill.questionnaire.with.appointment`}
          values={{
            name: item.name,
            strong: (chunks) => <strong>{chunks}</strong>,
          }}
        />
      );
    } else {
      return (
        <FormattedMessage
          id={`${module_id}.fill.questionnaire`}
          values={{ name: item.name }}
        />
      );
    }
  };

  let omavointiQuestionnaires = props.data;
  let { doRequestDismissNotificationsList } = props;

  return (
    <Notification>
      <OTIcon
        config={{ type: 'custom', name: 'kyselyt', color: 'darkblue' }}
        style={{ width: '17px', marginRight: '20px' }}
      />
      <h2 className="ot-notification__header">
        <FormattedMessage id={`${module_id}.new.questionnaire`} />
      </h2>
      {omavointiQuestionnaires.map((item) => {
        let description = getDescription(item);
        let endDateTime = get(item, 'endDateTime', null) ? (
          <FormattedMessage
            id={`${module_id}.fill.at.the.latest`}
            values={{
              date: getTime(item.endDateTime).format('DD.MM.YYYY'),
            }}
          />
        ) : null;
        return (
          <>
            {<div className="ot-notification__description">{description}</div>}
            {renderLongDescription(item)}
            {item.description && (
              <div className="ot-notification__description">
                <OTIcon
                  config={{
                    type: 'custom',
                    name: 'palaute',
                    color: 'darkblue',
                  }}
                  style={{ marginRight: '5px', height: '15px' }}
                />
                {item.description}
              </div>
            )}
            {showMobileClientModal && (
              <MobileClientModal
                isOpen={showMobileClientModal}
                hideModal={() => toggleModalState()}
              />
            )}
            {endDateTime}
          </>
        );
      })}
      <div className="ot-notification__description">
        <br />
        <FormattedMessage id={`${module_id}.info.questionnaire`} />
      </div>
      <Row>
        <div className="ot-notification__buttonrow">
          <OTButtonGroup collapseOnMobile expecedCount={2} fullWidth type="big">
            <OTButton
              className="ot-notification__button"
              onClick={fillClicked.bind(this, omavointiQuestionnaires[0])}
            >
              <FormattedMessage id={`navigate.to.answer`} />
            </OTButton>
            <OTButton
              onClick={() => {
                doRequestDismissNotificationsList(
                  Array.from(
                    omavointiQuestionnaires,
                    (item) => `${QUESTIONNAIRE_PAGE_NOTIFICATION}_${item.id}`
                  )
                );
              }}
            >
              <FormattedMessage id={`${module_id}.fill.later`} />
            </OTButton>
          </OTButtonGroup>
        </div>
      </Row>
    </Notification>
  );
}

const mapStateToProps = (state) => {
  let mobileClientState = state[QUESTIONNAIRES].mobileClientState;
  return {
    mobileClientState,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    doRequestDismissNotificationsList: (notificationId) =>
      dispatch(doRequestDismissNotificationsList([notificationId])),
    showOmavointiQuestionnaireModal: (...props) =>
      dispatch(showOmavointiQuestionnaireModal(...props)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuestionnaireNotificationList);
